import React, { useState, useMemo, useEffect } from "react";
import { useDispatch } from "react-redux";
import { R$ } from "../utils/brl";
import "../styles/selectDues.scss";
import Icon from "./layout/icon";
import { hasLogin, hasPixParam, hasWalletParam, hasWrapper } from "../../utils/getPreTickets";
import { emitIntent } from "../../newDesign/utils/emitIntent";
import { saveCart, getSavedCart, removeSavedCart } from "../../modules/localStorage";
import { Cart } from "./layout/cart/Cart";
import { RifaBuyerRanking } from "./layout/buyerRanking";
import { ShoppingCart, WhatsappLogo, Link } from "phosphor-react";
import { AwardedQuotas } from "./layout/awardedQuotas";

import {
  AnalyticsSetGameStep
} from "../../reducers/analytics/analyticsActions";
import { useWindow } from "../../hooks/useWindow";

function SelectDuesRifa({ rifa, finishBet, betValue, calculateAvailableQuotas, minimumAvailableQuotas, showError, session = {} }) {
  const [amount, setAmount] = useState(getSavedCart(rifa, 'rifa-cart') || minimumAvailableQuotas);
  const [hasInteracted, setHasInteracted] = useState(false);
  const { isMobile } = useWindow();

  const whatsAppNumber = session.VchWhatsApp || null;
  const linkInBio = session.VchLinkInBio || null;

  const [isPixParam] = useState(hasPixParam());
  const [isWalletParam] = useState(hasWalletParam());

  const quotaOptions = [10, 50, 100, 500];

  const dispatch = useDispatch();

  const validateWithLogin = () => {
    if (amount < minimumAvailableQuotas) {
      showError("Compra Inválida", `Quantidade minima de cotas: ${minimumAvailableQuotas}`);
    } else {
      if (hasLogin()) {
        removeSavedCart('rifa-cart');
        finishBet({ valorTotal, amount, isPreTicket: false, isPix: true }, clearCart);
      } else {
        saveCart(rifa, amount, 'rifa-cart');
        emitIntent("open_login");
      }
    }
  }

  function openWhatsApp() {
    emitIntent("open_window", { url: `https://api.whatsapp.com/send/?phone=${whatsAppNumber.replace(/\D/g, '')}&text&type=phone_number&app_absent=0`, target: "_blank" })
  }

  function openLinkInBio() {
    emitIntent("open_window", { url: linkInBio, target: "_blank" })
  }

  const valorTotal = useMemo(() => {
    return amount * betValue;
  }, [betValue, amount]);

  const setAmountValue = (funcState) => {
    dispatch(AnalyticsSetGameStep("Select Number"));
    setAmount((state) => {
      const newState = funcState(state);
      saveCart(rifa, (+newState <= minimumAvailableQuotas ? minimumAvailableQuotas : +newState), 'rifa-cart');
      return newState;
    });
  }

  function clearCart() {
    dispatch(AnalyticsSetGameStep("Clear Cart"));
    setAmountValue(() => minimumAvailableQuotas);
  }

  const floatingCartBets = amount > 0 ? [{ number: 0, alternativeText: `COTA${amount > 1 ? "S" : ""}`, label: `${amount}x` }] : []

  const useOldCart = !hasWrapper();

  return (
    <React.Fragment>
      {!useOldCart ? (<Cart
        forceOpened
        hideTotalAmount
        classNames={{
          finishButton: "dues-finish-button",
          footer: "dues-cart-footer",
          header: "dues-cart-header",
        }}
        labels={{
          finishButton: "Participar do sorteio"
        }}
        customOpenerTitle={<div style={{ position: "relative" }}>
          <span className={"dues-cart-title "}><ShoppingCart size={20} style={{ marginRight: "6px" }} />{amount} cota{amount != 1 ? "s" : ""} - {R$(valorTotal)}</span>
          {linkInBio ? <div className="floating-whatsapp-button">
            <span className="i-bg twitter" onClick={openLinkInBio}><Link weight="light" size={20} color="white" />Redes sociais</span>
          </div> : whatsAppNumber ? <div className="floating-whatsapp-button">
            <span className="i-bg whatsapp" onClick={openWhatsApp}><WhatsappLogo weight="light" size={20} color="white" />Whatsapp</span>
          </div> : null}
        </div>
        }
        hideBetsSection
        totalAmount={R$(valorTotal)}
        bets={floatingCartBets}
        onFinishClick={validateWithLogin}
        onRemoveClick={() => setAmountValue((state) => state > minimumAvailableQuotas ? state - 1 : minimumAvailableQuotas)}
        disableFinishButton={amount < minimumAvailableQuotas}
        onClearClick={clearCart}
        amountChooser={{
          show: true,
          label: "",
          currentAmount: amount,
          onIncrement: () => setAmountValue((state) => state + 1),
          onDecrement: () => setAmountValue((state) => state > minimumAvailableQuotas ? state - 1 : minimumAvailableQuotas),
          onManualChange: (val) => setAmountValue(() => +val),
          onManualLeave: () => setAmountValue(() => +amount),
          className: "dues-amount-chooser"
        }}
        messages={{
          afterTotals: amount < minimumAvailableQuotas ? <span style={{ color: "darkred", fontSize: "12px" }}>Selecione ao menos {minimumAvailableQuotas} cota{minimumAvailableQuotas != 1 ? "s" : ""}</span> : null
        }}
      />) : null}

      <div className="rifa-text-section">
        <div className="quota-container">
          {/* <p className="rifa-title text-center">Cotas</p> */}
          {!!calculateAvailableQuotas &&
            <h4><span>{`${calculateAvailableQuotas}%`}</span>{` de Cotas Disponíveis.`}</h4>
          }
        </div>
        {/* <span>Selecione a quantidade de cotas</span> */}
      </div>
      <section className="rifa-due">
        <div className="rifa-due__amount">
          <p>Adicione suas cotas</p>
          <div className="rifa-due__amount-grid">
            {quotaOptions.map((val) => {
              return <button
                className="mirrored-button"
                onClick={() => {
                  if (!hasInteracted) {
                    // Se já estiver salva no carrinho quantidade maior que o mínimo (usuário já interagiu anteriormente)
                    if (amount > minimumAvailableQuotas) setAmountValue((state) => state + val);
                    else setAmountValue((state) => val < minimumAvailableQuotas ? (minimumAvailableQuotas + val) : val);
                  } else {
                    setAmountValue((state) => state + val)
                  }

                  setHasInteracted(true);
                }}
              >
                <p>+{val.toString()}</p>
                <p className="rifa-due__subtitle">COTA{val > 1 ? "S" : ""}</p>
                {/* <p className="rifa-due__subtitle">COTA{val > 1 ? "S" : ""}</p> */}
              </button>
            })}
          </div>

          {useOldCart ? (<div className="rifa-due__input">
            <button
              className="default-button"
              onClick={() =>
                setAmountValue((state) => (state - 1 >= minimumAvailableQuotas ? state - 1 : state))
              }
              disabled={amount <= minimumAvailableQuotas}
            >
              <Icon color="black" type="minus" width="32" height="32" />
            </button>
            <input
              value={amount}
              type="number"
              onChange={(e) => {
                let intValue = parseInt(e.target.value);
                if (isNaN(intValue)) intValue = minimumAvailableQuotas;
                setAmountValue(() => Math.max(1, intValue));
              }}
            />
            <button
              className="default-button"
              onClick={() => setAmountValue((state) => state + 1)}
            >
              <Icon color="black" type="plus" />
            </button>
          </div>) : null}

        </div>

        {useOldCart && valorTotal > 0 ? <p className="rifa-due__result">Valor total: {R$(valorTotal)}</p> : null}
        {useOldCart ? <div className="rifa-cart-button-container">
          {(valorTotal > 0 && isWalletParam && amount >= minimumAvailableQuotas) &&
            <button
              className="button submit-button rifa-due__submit-button"
              onClick={() => finishBet({ valorTotal, amount, isPreTicket: false, isPix: false })}
            >
              Finalizar compra
            </button>
          }
          {(isPixParam && valorTotal > 0 && amount >= minimumAvailableQuotas) &&
            <button
              className="button submit-button rifa-due__submit-button rifa-button-full-width"
              onClick={() => validateWithLogin()}
            >
              Pagar Agora!
            </button>
          }
        </div> : null}
      </section>

      <RifaBuyerRanking buyerRanking={rifa.buyerRanking} style={{ marginBottom: "8px" }} />
      <AwardedQuotas awardedQuotas={rifa.awardedQuotas} maxVisible={isMobile ? 9 : 14} style={{ marginBottom: "8px" }} />
    </React.Fragment>
  );
}

export default SelectDuesRifa;



// WEBPACK FOOTER //
// ./src/rifa/components/selectDues.jsx